import cn from 'classnames';
import { memo, type FC } from 'react';
import { NavLink } from 'react-router-dom';
import { ChatIconMenu } from '@shared/assets';
import * as st from './styles.module.scss';

export const ButtonMessenger: FC = memo(() => {
  return (
    <>
      <NavLink to="/messenger" className={({ isActive }) => cn(st.btn, isActive && st.active)}>
        <ChatIconMenu />
      </NavLink>
    </>
  );
});
